import { Slider } from "@mui/material";
import { useContext, useState } from "react";
import { flexCentered } from "theme/base/flex";
import TimelinePlayerContext from "../context/TimelinePlayerContext";
import Scrubber_ValueLabel from "./Scrubber_ValueLabel";

export default function Scrubber({ disabled }: { disabled?: boolean }) {
  const [scrubbingTime, setScrubbingTime] = useState<number | undefined>();
  const {
    absoluteTime,
    setIsScrubbing,
    setSeekToAbsolutePosition,
    timelinePositions,
    totalDuration,
  } = useContext(TimelinePlayerContext);
  const value = scrubbingTime != undefined ? scrubbingTime : absoluteTime || 0;

  return (
    <Slider
      // disableSwap
      disabled={disabled}
      sx={{ height: ".5rem", flex: 1, ...flexCentered }}
      max={totalDuration}
      marks={Array.from(timelinePositions.keys())
        .slice(1)
        .map((value) => ({ value }))}
      onChange={(_, value) => {
        setIsScrubbing(true);
        setScrubbingTime(Math.floor(Number(value)));
      }}
      componentsProps={{
        mark: {
          style: { width: ".25rem", height: ".25rem", borderRadius: ".125rem" },
        },
      }}
      onChangeCommitted={() => {
        {
          setIsScrubbing(false);
          if (scrubbingTime == undefined) return;

          setSeekToAbsolutePosition(scrubbingTime);
          setScrubbingTime(undefined);
        }
      }}
      valueLabelDisplay="auto"
      valueLabelFormat={(value) => (
        <Scrubber_ValueLabel
          value={value}
          timelinePositions={timelinePositions}
        />
      )}
      step={0.1}
      size="small"
      value={value}
    />
  );
}
